import { createContext, useState, useEffect } from "react";
import { clearClientAuthData } from "../Components/Assets/AppConstant";
import { callMultipleApis } from "../services/ApiServices";


const getUserProfile = process.env.REACT_APP_USER_PROFILE_URL;

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("IS_AUTHENTICATED") === "true";

    if (isAuthenticated) {
      fetchUser();
    }

    setAuthLoading(false); // 🔑 VERY IMPORTANT
  }, []);

  const fetchUser = async () => {
    try {
      const [res] = await callMultipleApis([
        {
          url: getUserProfile,
          method: "POST",
          data: {},
          params: {},
          headers: {},
        }
      ]);


      if (res.status) {
        setUserDetails(res.result);
      } else {
        setUserDetails(null);
      }
    } catch {
      setUserDetails(null);
    }
  };

  const login = (userData) => {
    setUserDetails(userData);
    localStorage.setItem("IS_AUTHENTICATED", "true");
  };

  const logout = () => {
    setUserDetails(null);
    clearClientAuthData();
  };

  return (
    <AuthContext.Provider
      value={{ userDetails, authLoading, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
